import {
  GroupedStakeholderSegmentDropdownDocument,
  StakeholderListDocument,
  SurveyLanguage,
  UpdateStakeholderGroupInput,
  UpdateStakeholderGroupModal_StakeholderGroupFragment,
  useUpdateStakeholderGroupMutation,
} from '@/graphql/generated';

import { EditIcon } from '@/components/icons';
import { useModal } from '@/components/modals/Modal';
import { useTranslation } from '@/hooks/useTranslation';

import { StakeholderGroupForm } from '../form/StakeholderGroupForm';

type Props = {
  initialData: UpdateStakeholderGroupModal_StakeholderGroupFragment;
  initialLanguage: SurveyLanguage;
};

export const UpdateStakeholderGroupButton = ({
  initialData,
  initialLanguage,
}: Props) => {
  const modal = useModal();
  const { t } = useTranslation();
  const [updateStakeholderGroup] = useUpdateStakeholderGroupMutation();

  const openCreateIroModal = () => {
    modal.openModalWithComponent(
      <StakeholderGroupForm<UpdateStakeholderGroupInput>
        initialData={initialData}
        initialLanguage={initialLanguage}
        onSubmit={(input) =>
          updateStakeholderGroup({
            variables: { input },
            refetchQueries: () => [
              {
                query: StakeholderListDocument,
                variables: {
                  companyId: initialData.company?.id,
                },
              },
              {
                query: GroupedStakeholderSegmentDropdownDocument,
                variables: {
                  companyId: initialData.company?.id,
                },
              },
            ],
          })
        }
        onClose={modal.closeModal}
      />,
      t('stakeholder.group.update.modal.title'),
      false,
      false,
      undefined,
      'p-0',
    );
  };

  return (
    <button className="tertiary" onClick={openCreateIroModal}>
      <EditIcon className="w-4 h-4" />
    </button>
  );
};
